/* eslint-disable no-console */
//  Save counter
const counterDocuments = ({ documentName }) => {
  const dName = documentName.name;
  const str = documentName.name.replace(/\s/g, "%20");

  fetch(`https://administracionbiugb.ugb.edu.sv/api/couterdocuments/${str}/increment_downloads/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      name: `${dName}`,
    }),
  })
    .then((response) => response.json())
    .catch(() => {});
};

export default counterDocuments;
